/* eslint-disable camelcase */
export const DEFAULT_RULES = {
  auto_create_call_task: true,
  access_customer_docs: false,
  // create_new_users: false,
  create_task_on_lead: true,
  edit_closed_leads: false,
  edit_customer_details: false,
  edit_project_details: true,
  export_data: false,
  log_user_activity: true,
  see_all_contacts: true,
  see_all_customers: true,
  see_all_leads: true,
  transfer_leads: true,
  edit_property_details: true,
} as const;
